import React, {FC} from "react";

const NotFound: FC = () => {
  return (
    <div>
      <h1>Not Found</h1>
    </div>
  );
};

export default NotFound;
